const CARD_CONFIG = [
  { key: "overall", label: "Overall" },
  { key: "full_game", label: "Full Game" },
  { key: "f5", label: "First 5", experimental: true },
  { key: "nrfi", label: "NRFI" },
  { key: "yrfi", label: "YRFI" },
];

const MIN_FORWARD_SAMPLE = 100;

const ExperimentalBadge = ({ testId }) => (
  <span
    data-testid={testId}
    title="Current exported record for this market is a losing sample -- treat as experimental."
    className="rounded-full border border-amber-500/40 bg-amber-500/10 px-1.5 py-0.5 text-[9px] uppercase text-amber-400"
  >
    Experimental
  </span>
);

const Card = ({ label, stats, testId, experimental, showMinSampleNote }) => {
  const decided = stats.wins + stats.losses;
  return (
    <div data-testid={testId} className="flex flex-col gap-2 rounded-lg border border-white/10 bg-eb-surface p-4">
      <span className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wide text-zinc-500">
        {label}
        {experimental && <ExperimentalBadge testId={`${testId}-experimental-badge`} />}
      </span>
      <p data-testid={`${testId}-record`} className="font-heading text-2xl text-white">
        {stats.wins}-{stats.losses}-{stats.pushes}
      </p>
      <p data-testid={`${testId}-win-pct`} className="font-mono text-sm text-zinc-400">
        {stats.win_pct !== null ? `${stats.win_pct}%` : "No graded picks yet"}
      </p>
      {showMinSampleNote && decided < MIN_FORWARD_SAMPLE && (
        <p data-testid={`${testId}-min-sample-note`} className="font-mono text-[10px] text-zinc-600">
          Performance is preliminary until this market has {MIN_FORWARD_SAMPLE} forward-verified decisions.
        </p>
      )}
    </div>
  );
};

export const BestBetsSummary = ({ summary, sectionId = "best-bets", showMinSampleNote = false }) => (
  <div data-testid={`${sectionId}-summary`} className="grid grid-cols-2 gap-4 sm:grid-cols-5">
    {CARD_CONFIG.map(({ key, label, experimental }) => (
      <Card
        key={key}
        label={label}
        stats={summary[key]}
        testId={`${sectionId}-summary-${key}`}
        experimental={experimental}
        showMinSampleNote={showMinSampleNote}
      />
    ))}
  </div>
);
